import triyoAPI from "./triyo";
import { getToken } from "./api-util";

const config = () => {
  let token = getToken();
  return {
    method: "GET",
    credentials: "include",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

export const GetAllWorkflows = () => {
  return triyoAPI.get("/Workflow/GetAllWorkflows", config());
};

export const GetWorkflowById = (id) => {
  return triyoAPI.get("/Workflow/GetWorkflowById/" + id, config());
};

export const GetBadgeColors = () => {
  return triyoAPI.get("/Workflow/GetBadgeColorsAsync", config());
};

export const GetBaseWorkflowStatusesLegacy = (id) => {
  return triyoAPI.get("/Workflow/GetBaseWorkflowStatusesLegacy", config());
};

export const GetBaseWorkflowStatuses = (id) => {
  return triyoAPI.get("/Workflow/GetBaseWorkflowStatuses", config());
};

export const GetBaseWorkflowActions = (id) => {
  return triyoAPI.get("/Workflow/GetBaseWorkflowActions", config());
};

export const GetSystemWorkflowActions = (id) => {
  return triyoAPI.get("/Workflow/GetSystemWorkflowActions", config());
};

export const GetAllCustomReminders = (id) => {
  return triyoAPI.get("/Workflow/GetAllCustomReminders", config());
};

export const AddWorkflow = (workflowDto) => {
  return triyoAPI.post("/Workflow/AddWorkflow", workflowDto, config());
};

export const UpdateWorkflow = (workflowDto) => {
  return triyoAPI.post("/Workflow/UpdateWorkflow", workflowDto, config());
};

export const ArchiveWorkflow = (id, archive) => {
  return triyoAPI.get(
    "/Workflow/ArchiveWorkflow/" + id + "/" + archive,
    config()
  );
};

export const SyncWorkflow = (id) => {
  return triyoAPI.get("/Workflow/updateworkflow/" + id, config());
};

// export const GetWorkflowStatusConditions = (id, statusId, type) => {
//   return triyoAPI.get(`/workflow/statusconditions/${id}/${statusId}/${type}`, config());
// };

export const GetWorkflowActionConditions = (id, actionId, type) => {
  return triyoAPI.get(`/workflow/actionconditions/${id}/${actionId}/${type}`, config());
};

//Legacy GET API for workflow conditions`
export const GetWorkflowConditions = (id, statusId, type) => {
  return triyoAPI.get(`/workflow/conditions/${id}/${statusId}/${type}`, config());
};

// export const UpdateWorkflowStatusConditions = (id, statusId, data, type) => {
//   return triyoAPI.post(`/workflow/statusconditions/${id}/${statusId}/${type}`, data, config());
// };

export const UpdateWorkflowActionConditions = (id, actionId, data, type) => {
  return triyoAPI.post(`/workflow/actionconditions/${id}/${actionId}/${type}`, data, config());
};

//Legacy POST API for workflow conditions
export const UpdateWorkflowConditions = (id, statusId, data, type) => {
  return triyoAPI.post(`/workflow/conditions/${id}/${statusId}/${type}`, data, config());
};

export const CreateChatGroupWithToken = (data) => {
  return triyoAPI.post(
    `CreateChatGroupWithToken`,
    data,
    config()
  );
};

export const CreateChatWithAzureIdentity = (data) => {
  return triyoAPI.post(
    `createazureidentity`,
    data,
    config()
  );
};

export const CreateChatWithMSAL = (data) => {
  return triyoAPI.post(
    `createmsal`,
    data,
    config()
  );
};
